'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.responsivePropType = exports.normalizeResponsiveProp = exports.breakpointPrefix = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _isPlainObject = require('lodash/isPlainObject');

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var breakpointPrefix = exports.breakpointPrefix = function breakpointPrefix() {
  var breakpoint = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  return breakpoint ? breakpoint + '-' : '';
};

var normalizeResponsiveProp = exports.normalizeResponsiveProp = function normalizeResponsiveProp(value) {
  var responsiveMap = _extends({}, (0, _isPlainObject2.default)(value) ? value : { '': value });

  // Treat mobile as default.
  if (responsiveMap.mobile) {
    responsiveMap[''] = responsiveMap.mobile;
    delete responsiveMap.mobile;
  }

  return responsiveMap;
};

var responsivePropType = exports.responsivePropType = function responsivePropType(propType) {
  return _propTypes2.default.shape({
    mobile: propType,
    tablet: propType,
    desktop: propType
  });
};